import { Component, Input } from '@angular/core';
import { AuthService } from 'src/app/service/autenticacao/auth.service';

@Component({
  selector: 'app-prioridade-pessoa-idosa-aviso',
  templateUrl: './prioridade-pessoa-idosa-aviso.component.html',
  styleUrls: ['./prioridade-pessoa-idosa-aviso.component.css']
})
export class PrioridadePessoaIdosaAvisoComponent {

  @Input() prioridadePessoaIdosa: boolean | undefined = undefined;
  @Input() modoOperador = false;

  constructor(private authService: AuthService) {}

  get exibir(): boolean {
    if (this.prioridadePessoaIdosa !== undefined && this.prioridadePessoaIdosa !== null) {
      return this.prioridadePessoaIdosa === true;
    }

    const usuario: any = this.authService.usuarioLogado || this.authService.usuarioDTO;
    return !!(usuario && usuario.prioridadePessoaIdosa === true);
  }

}
